import React from "react";

const LineBreak = () => {
  return <div className="line_break"></div>;
};

export default LineBreak;
